"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonialsData = [{
  quote: "The Miss Yvonne delivers the freshest seafood right to my door. Truly premium quality!",
  author: "John D.",
  position: "Satisfied Customer"
}, {
  quote: "Supporting local fishermen while enjoying sustainable seafood has never been easier.",
  author: "Sarah M.",
  position: "Frequent Buyer"
}];
export default function Testimonials() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: bottomRef,
    isVisible: isBottomVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="customer-testimonials" className="relative w-full bg-background py-24 md:py-40 overflow-hidden">
      {}
      <div className="absolute top-0 bottom-0 left-8 w-[1px] bg-border/40 hidden lg:block" />
      <div className="absolute top-0 bottom-0 right-8 w-[1px] bg-border/40 hidden lg:block" />
      
      {}
      <div className="absolute top-32 right-12 origin-top-right rotate-90 hidden xl:block opacity-30">
        <span className="font-mono text-xs tracking-widest text-muted-foreground uppercase">
          30° 24' 42" N / 88° 49' 42" W
        </span>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-8 relative z-10">
        
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-16 md:mb-24 transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)] ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="font-mono text-sm tracking-widest uppercase text-muted-foreground mb-4 flex items-center gap-2">
            03 // The Logbook
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground max-w-3xl">
            Words from the Shore
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20 md:mb-32">
          {testimonialsData.map((testimonial, index) => <TestimonialCard key={index} data-index={index} testimonial={testimonial} index={index} />)}
        </div>

        {}
        <div ref={bottomRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 items-center pt-12 border-t border-border transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)] ${isBottomVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="lg:col-span-8">
            <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
              Experience the heritage of wild-caught seafood delivered directly to your door. Join thousands of satisfied customers who trust The Miss Yvonne for their premium catch.
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-foreground hover:text-background font-mono uppercase tracking-widest rounded-md px-10 py-6 h-auto transition-colors duration-150 w-full sm:w-auto shadow-md">
              <Link to="/ShopPage">Shop The Catch</Link>
            </Button>
          </div>
        </div>

      </div>
    </section>;
}
function TestimonialCard({
  testimonial,
  index,
  ...props
}: {
  testimonial: any;
  index: number;
  [key: string]: any;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const delay = index * 100;
  return <div ref={ref} style={{
    transitionDelay: `${delay}ms`
  }} className={`transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} {...props}>
      <Card className="h-full bg-background border border-border rounded-md shadow-sm hover:border-primary transition-colors duration-150 flex flex-col justify-between p-8 md:p-10 group">
        <CardContent className="p-0 mb-8">
          <Quote className="w-8 h-8 text-primary/20 mb-6 group-hover:text-primary/40 transition-colors duration-300" />
          <p className="font-serif text-xl md:text-2xl leading-relaxed text-foreground">
            "{testimonial.quote}"
          </p>
        </CardContent>
        <CardFooter className="p-0 flex flex-col items-start gap-1">
          <span className="font-sans font-medium text-foreground text-lg">
            {testimonial.author}
          </span>
          <span className="font-mono text-xs tracking-wider text-muted-foreground uppercase">
            {testimonial.position}
          </span>
        </CardFooter>
      </Card>
    </div>;
}